import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  max-width: 480px;
  width: 100%;
  margin: 0 auto;
  height: 100vh;
  background: #fff;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const Header = styled.div`
  background: #fff;
  padding: 16px 20px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #f0f0f0;
  flex-shrink: 0;
`;

export const BackButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  margin-right: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #333;
  font-size: 20px;
`;

export const HeaderTitle = styled.h1`
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const HeaderIcon = styled.img`
  width: 24px;
  height: 24px;
`;

export const FacilityInfo = styled.div`
  padding: 16px 20px;
  background: #F8F9FA;
  border-bottom: 1px solid #f0f0f0;
  flex-shrink: 0;
`;

export const FacilityName = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #333;
  text-align: left;
`;

export const FacilityLocation = styled.div`
  font-size: 13px;
  color: #666;
  margin-top: 4px;
  text-align: left;
`;

export const TalkList = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 16px 20px;
  display: flex;
  flex-direction: column-reverse;
  gap: 12px;
`;

export const TalkItem = styled.div`
  padding: 16px;
  background: #F8F9FA;
  border-radius: 12px;
`;

export const TalkHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
`;

export const ProfileImage = styled.img`
  width: 36px;
  height: 36px;
  border-radius: 18px;
  object-fit: cover;
  margin-right: 10px;
`;

export const UserInfo = styled.div`
  flex: 1;
`;

export const Username = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #333;
  text-align: left;
`;

export const Timestamp = styled.div`
  font-size: 12px;
  color: #999;
  margin-top: 2px;
  text-align: left;
`;

export const TalkContent = styled.div`
  font-size: 15px;
  color: #444;
  line-height: 1.5;
  white-space: pre-wrap;
  text-align: left;
`;

export const LoadingContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 20px;
  color: #999;
  font-size: 14px;
`;

export const EmptyContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: #999;
`;

export const EmptyText = styled.div`
  font-size: 15px;
  color: #666;
  margin-top: 12px;
`;

export const LoadMoreTrigger = styled.div`
  height: 20px;
`;

export const InputContainer = styled.div`
  background: #fff;
  border-top: 1px solid #e0e0e0;
  padding: 12px 20px;
  padding-bottom: calc(12px + env(safe-area-inset-bottom));
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
`;

export const TextInput = styled.input`
  flex: 1;
  height: 40px;
  padding: 0 16px;
  border: 1px solid #e0e0e0;
  border-radius: 20px;
  font-size: 14px;
  outline: none;
  background: #F8F9FA;

  &:focus {
    border-color: #1FBC70;
    background: #fff;
  }

  &::placeholder {
    color: #999;
  }
`;

export const SendButton = styled.button<{ disabled?: boolean }>`
  width: 40px;
  height: 40px;
  border-radius: 20px;
  background: ${({ disabled }) => disabled ? '#ccc' : '#1FBC70'};
  border: none;
  cursor: ${({ disabled }) => disabled ? 'not-allowed' : 'pointer'};
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
  flex-shrink: 0;

  &:hover {
    background: ${({ disabled }) => disabled ? '#ccc' : '#18a863'};
  }

  svg {
    color: #fff;
    font-size: 16px;
  }
`;

export const ContentWrapper = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
`;
